ACDiscountApp.PDPage.DisplayTiers = function () {
    let intervalId;
    var tabelSelectorPDpage = '#product-box #add-to-cart-form button[name="add"] notuse';
    var tabelQuantitySelectorPDpage = 'quantity-input input[name="quantity"]';
    var addToCartSelecter = 'form[action="/cart/add"] .product-form__buttons';
    var VarintChangeSelectorPDpage = ".product.product--large.product--two_columns_grid.product--compact   #variant-picker .no-js-hidden .product-form__input  .form__variants label";
    var storeTime = globalFields.Storetime();
    let [currentYear, currentMonth, currentDay, currentHours, currentMinutes, currentSeconds] = storeTime.split(/[\sT:-]/);
    currentYear = parseInt(currentYear);
    currentMonth = parseInt(currentMonth);
    currentDay = parseInt(currentDay);
    currentHours = parseInt(currentHours);
    currentMinutes = parseInt(currentMinutes);
    currentSeconds = parseInt(currentSeconds);
    function makeTimer(end_date) {
        if (globalFields.isProduct_Page) {
            if (end_date != null) {
                jQuery("#ac_countDown").css("display", "inline-block");
                jQuery("#ac_countDown").css("width", "100%");
                jQuery("#ac_countDown").css("margin-bottom", "13px");
                jQuery("#ac_countDown").css("margin-top", "6px");
                jQuery("#ac_countDown").css("border-radius", "2px");
                jQuery("#ac_countDown").css("border", "#000 1px solid");
                jQuery("#ac_countDown").css("padding", "6px 0px 0px 0px");
                jQuery("#ac_countDown").css("font-family", '"Helvetica","Helvetica Neue",Arial,sans-serif');

                var endTime = end_date;
                currentSeconds++;
                if (currentSeconds >= 60) {
                    currentSeconds = 0;
                    currentMinutes++;
                    if (currentMinutes >= 60) {
                        currentMinutes = 0;
                        currentHours++;
                        if (currentHours >= 24) {
                            currentHours = 0;
                            currentDay++;
                        }
                    }
                }
                let currentStoreTime = `${currentYear}-${currentMonth.toString().padStart(2, "0")}-${currentDay.toString().padStart(2, "0")}T${currentHours.toString().padStart(2, "0")}:${currentMinutes
                    .toString()
                    .padStart(2, "0")}:${currentSeconds.toString().padStart(2, "0")}`;
                endTime = Date.parse(endTime) / 1000;
                var now = currentStoreTime;
                now = Date.parse(now) / 1000;
                var timeLeft = endTime - now;
                var days = Math.floor(timeLeft / 86400);
                var hours = Math.floor(timeLeft / 3600);
                var exactHour = hours % 24;
                var minutes = Math.floor((timeLeft - hours * 3600) / 60);
                var seconds = Math.floor(timeLeft - hours * 3600 - minutes * 60);
                var isDays = !1;
                if (days > 0 || hours > 24) {
                    isDays = !0;
                }
                if (days < 0) {
                    days = "00";
                }
                if (hours < 10) {
                    hours = "0" + hours;
                }
                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                if (seconds < 10) {
                    seconds = "0" + seconds;
                }
                if (timeLeft > 0) {
                    if (isDays) {
                        jQuery(".ac__days").html(days);
                        jQuery(".ac__hours").html(exactHour);
                        jQuery(".ac__minutes").html(minutes);
                        jQuery(".ac__seconds").html(seconds);
                    } else {
                        jQuery(".ac__hours").html(exactHour);
                        jQuery(".ac__minutes").html(minutes);
                        jQuery(".ac__seconds").html(seconds);
                        jQuery(".ac_day, .ac__colon.hours").hide();
                        jQuery(".ac_sec, .ac__colon.seconds").show();
                    }
                } else {
                    jQuery('.product.product--large.product--two_columns_grid.product--compact .product-form__buttons, #ac_countDown').remove();
                }
                setTimeout(function () {
                    jQuery('.product.product--large.product--two_columns_grid.product--compact .product-form__buttons').before(jQuery("#ac_countDown"));
                }, 500);
            }
        }
    }
    var hide_buttons = null;
    var HideAdditionalPayments = function () {
        hide_buttons = setInterval(function () {
            if (jQuery(".shopify-payment-button__button").length > 0) {
                jQuery(".shopify-payment-button__button").hide();
                clearInterval(hide_buttons);
            }
        }, 500);
    };
    this.DisplayTiersFn = function () {
        setTimeout(function () {
            if (intervalId) {
                clearInterval(intervalId);
            }
            jQuery(".ac__settings__table").remove();
            var selectedVariant =getSelectedVariant();
                    var  TempselectedVariant = jQuery("input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]", jQuery('form[data-type="add-to-cart-form"],#add-to-cart-form')).val();
        if (!selectedVariant || selectedVariant == "") {
         selectedVariant = TempselectedVariant
        }
            let ProductPage = globalFields.TableProductPage != undefined && globalFields.TableProductPage != "" ? globalFields.TableProductPage : "true";
            ProductPage = ProductPage == "true" ? !0 : !1;
            let tierData = globalFieldsProductPage_AC.product_metafields;
            let productMetafieldValidation = filterProductMetafields(tierData, Number(selectedVariant));
            if (selectedVariant != null && productMetafieldValidation != undefined && productMetafieldValidation.status && ProductPage) {
                let tierObj = productMetafieldValidation;
                let DiscountAppliedOn = !1;
                let Location_Tag_s = !1;
                if (tierObj != undefined) {
                    DiscountAppliedOn = tierObj.DiscountAppliedON != null && tierObj.DiscountAppliedON != "" && tierObj.DiscountAppliedON != undefined ? !0 : !1;
                    Location_Tag_s = tierObj.Location_Tag_ != null && tierObj.Location_Tag_ != "" && tierObj.Location_Tag_ != undefined ? !0 : !1;
                }
                if (DiscountAppliedOn) {
                    if (Location_Tag_s) {
                        let DiscountAppliedOnTag = tierObj.DiscountAppliedON == "Both_Store" || tierObj.DiscountAppliedON == "Online_Store" ? !0 : !1;
                        let LocationObject = Object.keys(tierObj.Location_Tag_);
                        if (LocationObject[0] == "StoreLocation") {
                            let StoreLocationcheck = tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? !0 : !1;
                            if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && StoreLocationcheck) {
                                var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
                                getDates.valid;
                                getDates.start_date;
                                getDates.end_date;
                                let timer_settings = parsed_timer_settings;
                                WriteTableHeading(tierObj);
                                WriteTableRows(tierObj, selectedVariant);
                                if (timer_settings != undefined) {
                                    if (timer_settings.TimerStatus) {
                                        if (getDates.valid) {
                                            if (intervalId) {
                                                clearInterval(intervalId);
                                            }
                                            intervalId = setInterval(function () {
                                                makeTimer(getDates.end_date);
                                            }, 1000);
                                        }
                                    }
                                }
                                jQuery(".shopify-payment-button__button").hide();
                                setTimeout(function () {
                                    jQuery(".shopify-payment-button__button").hide();
                                    HideAdditionalPayments();
                                }, 2000);
                                setTimeout(function () {
                                    clearInterval(hide_buttons);
                                }, 5000);
                            }
                        } else {
                            let TierLocation = tierObj.Location_Tag_[LocationObject[0]];
                            let CusotmerCountryLocation = globalFields.Customercountry;
                            let CusotmerCityLocation = globalFields.Customercity;
                            let CustomerLocationcheck_1 = (arr, arr1) => {
                                return arr.some((item) => arr1.includes(item));
                            };
                            let CustomerLocationcheck_2 = (arr2, arr3) => {
                                return arr2.some((item) => arr3.includes(item));
                            };
                            let CityValue = CustomerLocationcheck_1(TierLocation, CusotmerCountryLocation);
                            let CountryValue = CustomerLocationcheck_2(TierLocation, CusotmerCityLocation);
                            if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && (CityValue || CountryValue)) {
                                var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
                                getDates.valid;
                                getDates.start_date;
                                getDates.end_date;
                                let timer_settings = parsed_timer_settings;
                                WriteTableHeading(tierObj);
                                WriteTableRows(tierObj, selectedVariant);
                                if (timer_settings != undefined) {
                                    if (timer_settings.TimerStatus) {
                                        if (getDates.valid) {
                                            if (intervalId) {
                                                clearInterval(intervalId);
                                            }
                                            intervalId = setInterval(function () {
                                                makeTimer(getDates.end_date);
                                            }, 1000);
                                        }
                                    }
                                }
                                jQuery(".shopify-payment-button__button").hide();
                                setTimeout(function () {
                                    jQuery(".shopify-payment-button__button").hide();
                                    HideAdditionalPayments();
                                }, 2000);
                                setTimeout(function () {
                                    clearInterval(hide_buttons);
                                }, 5000);
                            }
                        }
                    } else {
                        if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && (tierObj.DiscountAppliedON == "Both_Store" || tierObj.DiscountAppliedON == "Online_Store")) {
                            var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
                            getDates.valid;
                            getDates.start_date;
                            getDates.end_date;
                            let timer_settings = parsed_timer_settings;
                            WriteTableHeading(tierObj);
                            WriteTableRows(tierObj, selectedVariant);
                            if (timer_settings != undefined) {
                                if (timer_settings.TimerStatus) {
                                    if (getDates.valid) {
                                        if (intervalId) {
                                            clearInterval(intervalId);
                                        }
                                        intervalId = setInterval(function () {
                                            makeTimer(getDates.end_date);
                                        }, 1000);
                                    }
                                }
                            }
                            jQuery(".shopify-payment-button__button").hide();
                            setTimeout(function () {
                                jQuery(".shopify-payment-button__button").hide();
                                HideAdditionalPayments();
                            }, 2000);
                            setTimeout(function () {
                                clearInterval(hide_buttons);
                            }, 5000);
                        }
                    }
                } else {
                    let temptimer = globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date);
                    if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
                        var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
                        getDates.valid;
                        getDates.start_date;
                        getDates.end_date;
                        let timer_settings = parsed_timer_settings;
                        WriteTableHeading(tierObj);
                        WriteTableRows(tierObj, selectedVariant);
                        if (timer_settings != undefined) {
                            if (timer_settings.TimerStatus) {
                                if (getDates.valid) {
                                    if (intervalId) {
                                        clearInterval(intervalId);
                                    }
                                    intervalId = setInterval(function () {
                                        makeTimer(getDates.end_date);
                                    }, 1000);
                                }
                            }
                        }
                        jQuery(".shopify-payment-button__button").hide();
                        setTimeout(function () {
                            jQuery(".shopify-payment-button__button").hide();
                            HideAdditionalPayments();
                        }, 2000);
                        setTimeout(function () {
                            clearInterval(hide_buttons);
                        }, 5000);
                    }
                }
            }
        }, 200);
    };
    setTimeout(function () {
        clearInterval(hide_buttons);
    }, 10000);


function getSelectedVariant() {
    try {
        // Define your selectors cleanly
        const variantSelector = `input[name^="id"]:checked,
                                 select[name^="id"],
                                 input[name="id"],
                                 input[type="hidden"][name^="id"]`;

        // Try first form sources
        const primaryForm = jQuery('form[action="/cart/add"], #add-to-cart-form');
        let selectedVariant = primaryForm.find(variantSelector).val();

        // If empty/undefined/null then fallback
        if (!selectedVariant) {
            const secondaryForm = jQuery('form[data-type="add-to-cart-form"], #add-to-cart-form');
            selectedVariant = secondaryForm.find(variantSelector).val();
        }

        // Final safety check
        if (!selectedVariant) {
            return null;
        }

        return selectedVariant;

    } catch (err) {
        console.error("Error while getting selected variant:", err);
        return null;
    }
}






    jQuery(document).on("click", VarintChangeSelectorPDpage, function () {
     if (intervalId) {
                    clearInterval(intervalId);
                }
                displayTiers.DisplayTiersFn();
                setTimeout(function () {
                    displayTiers.changePrice();
                }, 1500);
                     setTimeout(function () {
                    displayTiers.changePrice();
                }, 3000);
});
    this.OnVariantChange = function () {
        // setTimeout(function () {
        //     jQuery(VarintChangeSelectorPDpage).click(function () {
        //         if (intervalId) {
        //             clearInterval(intervalId);
        //         }
        //         displayTiers.DisplayTiersFn();
        //         setTimeout(function () {
        //             displayTiers.changePrice();
        //         }, 1000);
        //     });

        // }, 2000);
    };
    var TableHeadHtml = function (contentHtml, tableSelector, position) {
        let tableShowAfter = !1;
        jQuery(tableSelector)[globalFields.settings.table_body.table_placed == "after" ? "after" : "before"](contentHtml);
    };
    var WriteTableHeading = function (tierObj) {
        var tableSelector = tabelSelectorPDpage;
        if (globalFields.settings.selected_table == "table1") {
            TableHeadHtml(
                '<table class="ac__settings__table ac_table1" id="ac_table1"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1" style=" word-break: auto-phrase; " >' +
                    globalFields.settings.table_headers.header1_value +
                    '</th><th class="ac__th ac__th2" style=" word-break: auto-phrase; " >' +
                    globalFields.settings.table_headers.header2_value +
                    "</th></tr></tbody></table>",
                tableSelector
            );
        }
        if (globalFields.settings.selected_table == "table2") {
            TableHeadHtml(
                '<table class="ac__settings__table ac_table2" id="ac_table2"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1" style=" word-break: auto-phrase; " >' +
                    globalFields.settings.table_headers.header1_value +
                    '</th><th class="ac__th ac__th2" style=" word-break: auto-phrase; ">' +
                    globalFields.settings.table_headers.header2_value +
                    '</th><th class="ac__th ac__th3" style=" word-break: auto-phrase; " >' +
                    globalFields.settings.table_headers.header3_value +
                    "</th></tr></tbody></table>",
                tableSelector
            );
        }
        if (globalFields.settings.selected_table == "table3") {
            TableHeadHtml(
                '<table class="ac__settings__table ac_table3" id="ac_table3"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1" style=" word-break: auto-phrase; ">' +
                    globalFields.settings.table_headers.header1_value +
                    '</th><th class="ac__th ac__th2" style=" word-break: auto-phrase; " >' +
                    globalFields.settings.table_headers.header2_value +
                    '</th><th class="ac__th ac__th3" style=" word-break: auto-phrase; ">' +
                    globalFields.settings.table_headers.header3_value +
                    "</th></tr></tbody></table>",
                tableSelector
            );
        }
        if (globalFields.settings.selected_table == "table4") {
            TableHeadHtml('<table class="ac__settings__table ac_table4" id="ac_table4"><tbody class="ac__tbody"></tbody></table>', tableSelector);
        }
        if (globalFields.settings.selected_table == "table5") {
            TableHeadHtml('<div class="ac__settings__table ac_table5" id="ac_table5" style="border: none;"><div class="ac__tbody"></div></div>', tableSelector);
        }
    };
    var TableRowHtml = function (contentHtml, tableSelector) {
        jQuery(tableSelector).append(contentHtml);
    };
    function formatNumberWithCommas(number) {
        if (typeof number !== "number") {
            return number;
        }
        return number;
    }
    var TableRowSingle = function (tieredMin_, tieredMax_, discountedPrice, tieredOff, mostPopularValues, index, originalPrice_, lastLength) {
        let mostPopular = mostPopularValues ? `<br><span class="ac_mostpopuler">Most Popular</span>` : "";
        var plusSign = tieredMin_ == tieredMax_ ? "" : "+",
            buyText = "Buy ";
        var priceHtml =
            '<span class="money ac_money" data-currency-' +
            globalFields.currency.toLowerCase() +
            '="' +
            globalFields.currencySymbol +
            discountedPrice +
            '" data-currency="' +
            globalFields.currency +
            '">' +
            globalFields.formatMoney(discountedPrice, globalFields.amount) +
            "</span>";
        if (globalFields.settings.selected_table == "table1") {
            TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + mostPopular + '</td><td class="ac__td ac__td2">' + tieredOff + "</td></tr>", "#ac_table1 .ac__tbody");
        }
        if (globalFields.settings.selected_table == "table2") {
            TableRowHtml(
                '<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + mostPopular + '</td><td class="ac__td ac__td2">' + tieredMax_ + '</td><td class="ac__td ac__td3">' + tieredOff + "</td></tr>",
                "#ac_table2 .ac__tbody"
            );
        }
        if (globalFields.settings.selected_table == "table3") {
            TableRowHtml(
                '<tr class="ac__tr ac__tr' +
                    (index + 1) +
                    '"> <td class="ac__td ac__td1">' +
                    globalFields.settings.table_body.body1_value +
                    " " +
                    tieredMin_ +
                    plusSign +
                    mostPopular +
                    '</td><td class="ac__td ac__td2">' +
                    priceHtml +
                    '</td><td class="ac__td ac__td3">' +
                    tieredOff +
                    "</td></tr>",
                "#ac_table3 .ac__tbody"
            );
        }
        if (globalFields.settings.selected_table == "table4") {
            var quantityTextTable4 = tieredMin_ + "-" + tieredMax_;
            if (tieredMax_ == "+") {
                quantityTextTable4 = tieredMin_ + "+";
            }
            TableRowHtml(
                '<tr class="ac__tr ac__tr' + index + '"> <td class="ac__td ac__td1">' + globalFields.settings.table_body.body1_value + " " + tieredMin_ + " " + globalFields.settings.table_body.body2_value + " " + tieredOff + "</td></tr>",
                "#ac_table4"
            );
        }
        if (globalFields.settings.selected_table == "table5") {
            let grabThisdealBtn = lastLength == index ? `<button class="ac_grab_deal_btn ac__th" type="button" > ${globalFields.settings.table_body.body2_value} </button>` : "";
            TableRowHtml(
                '<div class="ac_main_container ac__td"> <div class="ac_offer-option-item"> <label for="' +
                    tieredMin_ +
                    '" id="label_card_' +
                    (index + 1) +
                    '"> <input type="radio" name="card_group" value="' +
                    tieredMin_ +
                    '" class="ac-quantity-input-box tier_value" aria-labelledby="label_card_' +
                    (index + 1) +
                    '" data-gtm-form-interact-field-id="' +
                    (index + 1) +
                    '" />  </label> </div> <div class="ac_offer-option"> <div>  <span>' +
                    globalFields.settings.table_body.body1_value +
                    " " +
                    formatNumberWithCommas(tieredMin_) +
                    " " +
                    globalFields.settings.table_headers.header2_value +
                    ' </span>  <span class="money ac_money">' +
                    tieredOff +
                    "</span>  <span>" +
                    globalFields.settings.table_headers.header3_value +
                    "</span>" +
                    mostPopular +
                    '</div>  </div> <div class="ac_offer-option_price"> <div class="ac_option-item-price"> <div class="ac_item-regular_price"> <span class="money ac_money">' +
                    tieredOff +
                    '</span> <s class="money ac_money">' +
                    globalFields.formatMoney(originalPrice_ * 100, globalFields.amount) +
                    '</s> </div> </div> <div class="ac_option-total-price"> <div class="ac_item-regular_price"> <div class="ac-total-price"> ' +
                    globalFields.settings.table_headers.header1_value +
                    '</div> <s class="money ac_money">' +
                    globalFields.formatMoney((tieredMin_ * originalPrice_).toFixed(2), globalFields.amount) +
                    '</s> <span class="money ac_money">  ' +
                    globalFields.formatMoney((tieredMin_ * Number(discountedPrice)).toFixed(2), globalFields.amount) +
                    "</span> </div> </div> </div> </div>" +
                    grabThisdealBtn +
                    " ",
                "#ac_table5 .ac__tbody"
            );
            if (lastLength == index) {
                GrabThisDeal();
            }
        }
    };
    var WriteTableRows = function (tierObj, selectedVariant_) {
        var originalPrice_ = globalFieldsProductPage_AC.variantsPriceArray_PD[selectedVariant_];
        originalPrice_ = originalPrice_ / 100;
        for (i = 0; i < tierObj.tier_min.length; i++) {
            var isBreakLoop = !1,
                tieredOff = Number(tierObj.tier_values[i]);
            var tieredMin_ = parseInt(tierObj.tier_min[i]),
                tieredMax_ = tierObj.tier_max[i],
                discountedPrice = 0;
            if (tieredMax_ != "max") {
                tieredMax_ = parseInt(tieredMax_);
            } else {
                tieredMax_ = "+";
            }
            if (tierObj.discount_type == "percentage") {
                discountedPrice = Number(originalPrice_.toFixed(2));
                var p = parseFloat(tieredOff) / 100,
                    originalPriceCut_ = Number(parseFloat(p * discountedPrice).toFixed(2));
                discountedPrice = discountedPrice - originalPriceCut_;
                if (discountedPrice <= 0) {
                    discountedPrice = 0;
                    tieredOff = "100%";
                    isBreakLoop = !0;
                    tieredMax_ = "+";
                } else {
                    discountedPrice = discountedPrice.toFixed(2);
                    tieredOff = tieredOff + "% OFF";
                }
            } else if (tierObj.discount_type == "fixed_price") {
                discountedPrice = tieredOff.toFixed(2);
                tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
            } else {
                discountedPrice = Number((originalPrice_ - tieredOff).toFixed(2));
                if (discountedPrice <= 0) {
                    discountedPrice = 0;
                    tieredOff = globalFields.formatMoney(originalPrice_.toFixed(2), globalFields.amount);
                    isBreakLoop = !0;
                    tieredMax_ = "+";
                } else {
                    discountedPrice = discountedPrice.toFixed(2);
                    tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount) + " OFF";
                }
            }
            let lastLength = isBreakLoop ? i + 1 : tierObj.tier_min.length;
            let booleanmostPopularValues = tierObj.mostPopularValues != undefined ? (tierObj.mostPopularValues[i] != undefined ? tierObj.mostPopularValues[i] : !1) : !1;
            if (discountedPrice > 0 && Number(originalPrice_) >= Number(discountedPrice)) {
                TableRowSingle(tieredMin_, tieredMax_, discountedPrice, tieredOff, booleanmostPopularValues, i + 1, originalPrice_, lastLength);
            }
            if (isBreakLoop) {
                break;
            }
        }
    };
    this.changePrice = function () {
     
        // var selectedVariant = jQuery("input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]", jQuery('form[action="/cart/add"],#add-to-cart-form')).val();
        var selectedVariant = getSelectedVariant();

        let currencyRate = Shopify.currency.rate;
        currencyRate = Number(currencyRate);
        var  TempselectedVariant = jQuery("input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]", jQuery('form[data-type="add-to-cart-form"],#add-to-cart-form')).val();

        if (!selectedVariant || selectedVariant == "") {
            let id_ = Object.keys(globalFieldsProductPage_AC.variantsPriceArray_PD);
            selectedVariant = id_[0];
        }
        var mainProductPrice = globalFields.priceChangeFunc(selectedVariant);
        var mainProductPriceWithMoney = globalFields.formatMoney(mainProductPrice, globalFields.amount);
        var originalChangeQty = jQuery('input[name="quantity"]').val();
        originalChangeQty = Number(originalChangeQty);
        if (isNaN(originalChangeQty)) {
            originalChangeQty = 1;
        }
        var updatedItemPrice = 0;
        let tierData = globalFieldsProductPage_AC.product_metafields;
        let productMetafieldValidation = filterProductMetafields(tierData, Number(selectedVariant));
        
        jQuery(".discount-badge").remove();
        if (selectedVariant != null && productMetafieldValidation != undefined && productMetafieldValidation.status && selectedVariant != "") {
            let tierObj = productMetafieldValidation;
            let tier_range_value = "";
            if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
                for (i = 0; i < tierObj.tier_min.length; i++) {
                    var tierPrice = parseFloat(tierObj.tier_values[i]);
                    var minTier = parseInt(tierObj.tier_min[i]),
                        maxTier = tierObj.tier_max[i] != "max" ? parseInt(tierObj.tier_max[i]) : tierObj.tier_max[i];
                    var updatedLinePrice = 0,
                        condition1 = !1,
                        condition2 = !1;
                    var originalPrice_ = mainProductPrice / 100;
                    originalPrice_ = originalPrice_;
                    originalPrice_ = Number(originalPrice_);
                    originalChangeQty = tierObj.tier_min[0];
                    condition1 = originalChangeQty >= minTier;
                    condition2 = maxTier == "max" || originalChangeQty <= maxTier;
                    if (condition1 && condition2) {
                        break;
                    }
                }
                if (condition1 && condition2) {
                    if (tierObj.discount_type == "percentage") {
                        var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(originalPrice_)));
                        updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - originalPriceCut);
                        tier_range_value = `${tierPrice}%`;
                    } else if (tierObj.discount_type == "fixed") {
                        updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - parseFloat(tierPrice * currencyRate));
                        tier_range_value = `${globalFields.formatMoney(tierPrice * currencyRate * 100, globalFields.amount)}`;
                    } else if (tierObj.discount_type == "fixed_price") {
                        updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice * currencyRate));
                        tier_range_value = `${globalFields.formatMoney(tierPrice * currencyRate * 100, globalFields.amount)}`;
                    }
                    updatedItemPrice = globalFields.formatMoney(Number(updatedItemPrice).toFixed(2), globalFields.amount);
                    jQuery(".discount-badge").remove();
                    jQuery(".ac-custom-div").css({ position: "relative", display: "flex" });
                    jQuery("#product-box .entry-content .ac-custom-div,.discount-badge").append(
                        `<div class="main-cntr discount-badge" style="position: relative;bottom: 4px;left: 4px;height: 50px;max-height: 100px;font-size: 16px;font-weight: 300;"> <div class="ac-tier-range"><span>- ${tier_range_value}</span></div> </div>`
                    );
                    jQuery(" .product.product--large.product--two_columns_grid.product--compact  .product-form .product-form__buttons .product-form__submit  .price-inside-button,.ac-discounted-price").html(
                        ` <span class="money  ac-discounted-price"><s> ${mainProductPriceWithMoney}</s><span style="font-weight: 100;margin: 0px 4px;">-${tier_range_value}</span><span style="color: #f06868;"> ${updatedItemPrice}</span></span>`
                    );
                } else {
                    jQuery(".product.product--large.product--two_columns_grid.product--compact  .product-form .product-form__buttons .product-form__submit  .price-inside-button,.ac-discounted-price").html(`<span class="money ac-discounted-price" > ${mainProductPriceWithMoney} </span>`);
                }
            }
        } else {
            jQuery(" .product.product--large.product--two_columns_grid.product--compact  .product-form .product-form__buttons .product-form__submit  .price-inside-button,.ac-discounted-price").html(`<span class="money ac-discounted-price"> ${mainProductPriceWithMoney} </span>`);
        }
    };
    var GrabThisDeal = function () {
        let quantityInputContainer = document.querySelector(tabelQuantitySelectorPDpage);
        let radioBtnValue = document.querySelector(".ac-quantity-input-box");
        let acMainContainer = document.querySelector(".ac_main_container");
        let quantityInputValue = radioBtnValue.value;
        radioBtnValue.checked = !0;
        acMainContainer.classList.add("ac-active");
        if (quantityInputContainer) {
            quantityInputContainer.value = quantityInputValue;
        }
        jQuery(".ac_main_container").on("click", function () {
            quantityInputContainer = document.querySelector(tabelQuantitySelectorPDpage);
            quantityInputValue = jQuery(this).find(".ac-quantity-input-box").val();
            jQuery(this).find(".ac-quantity-input-box").prop("checked", !0);
            if (!document.querySelector(".ac-quantity-input-box").checked) {
                radioBtnValue.style.backgroundColor = "";
                acMainContainer.style.backgroundColor = "";
            }
            jQuery(".ac_main_container").removeClass("ac-active");
            jQuery(this).addClass("ac-active");
        });
        jQuery(".ac_grab_deal_btn").click(function () {
            quantityInputContainer = document.querySelector(tabelQuantitySelectorPDpage);
            if (quantityInputContainer) {
                quantityInputContainer.value = quantityInputValue;
            }
            if (globalFields.settings.table_body.gtd_add_to_cart) {
                jQuery(addToCartSelecter).click();
            }
        });
    };
};
window.addEventListener("load", (event) => {
    setTimeout(function () {
        displayTiers.changePrice();
    }, 800);
    displayTiers.changePrice();
});
var globalFieldsProductPage_AC = new ACDiscountApp.PDPage.Global(),
    displayTiers = new ACDiscountApp.PDPage.DisplayTiers();
displayTiers.DisplayTiersFn();
displayTiers.OnVariantChange();
displayTiers.changePrice();
